<template>
  <transition name="fade">
    <div class="full-screen-modal">
      <i
        v-if="showCloseButton"
        class="fa fa-times close-button"
        @click="$emit('close')"
      ></i>
      <div class="modal-content" :class="className">
        <div class="content-wrapper">
          <slot name="custom-content"></slot>
          <!-- Default content if no slot is provided -->
          <img
            v-if="modalHeaderImage"
            class="modal-image mt-2 mb-3"
            :src="modalHeaderImage"
            alt="modal_header"
          />
          <p
            class="text-center title-text mb-3"
            v-if="modalHeaderTitle"
            v-html="modalHeaderTitle"
          ></p>
          <p
            class="text-center subtitle-text mb-5"
            v-if="modalHeaderSubtitle"
            v-html="modalHeaderSubtitle"
          ></p>
        </div>
        <div class="actions-wrapper">
          <slot v-if="showActions">
            <Button
              class="w-100"
              @click="modalAction"
              :type="btnType"
              :loading="actionModalLoading"
            >
              <span>{{ btnText }}</span>
            </Button>
            <p
              v-if="btn2Text"
              class="second-button text-center mt-3 mb-0 px-3"
              @click="modalAction2"
            >
              {{ btn2Text }}
            </p>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>
<script setup lang="ts">
import Button from "@/apps/credit-line/components/Button.vue";

defineProps({
  modalHeaderImage: {
    type: String,
    default: "",
  },
  modalHeaderTitle: {
    type: String,
    default: "",
  },
  modalHeaderSubtitle: {
    type: String,
    default: "",
  },
  showActions: {
    type: Boolean,
    default: true,
  },
  btnText: {
    type: String,
  },
  btnType: {
    type: String,
    default: "primary",
  },
  actionModalLoading: {
    type: Boolean,
    default: false,
  },
  btn2Text: {
    type: String,
    default: "",
  },
  className: {
    type: String,
    default: "",
  },
  showCloseButton: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits<{
  (e: "modalAction", value: boolean): void;
  (e: "modalAction2", value?: boolean): void;
  (e: "close"): void;
}>();

const modalAction = () => {
  emit("modalAction", false);
};

const modalAction2 = () => {
  emit("modalAction2", false);
};
</script>
<style scoped>
.full-screen-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 999;
  overflow-y: auto;
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 24px;
  color: #111;
  cursor: pointer;
  z-index: 1001;
}

.modal-content {
  padding: 60px 16px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 100%;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.actions-wrapper {
  width: 100%;
  padding-bottom: 16px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.modal-image {
  width: 64px;
  height: 64px;
}

.title-text {
  font-family: Inter, serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #111;
  text-align: center;
}

.subtitle-text {
  font-family: Inter, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: #595a5a;
  text-align: center;
}

.second-button {
  font-family: Inter, serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #007c3b;
  cursor: pointer;
}
</style>
